import * as React from "react";
import { CollapseTrigger } from "../../collapse/collapse-trigger/collapse-trigger.mjs";
import { CollapseLayer } from "../../collapse-layer/collapse-layer/collapse-layer.mjs";
import { CollapseLayerGrid } from "../../collapse-layer/collapse-layer-grid/collapse-layer-grid.mjs";
import { CollapseLayerProvider } from "../../collapse-layer/collapse-layer-provider/collapse-layer-provider.mjs";
import { CollapseToggle } from "../../collapse-toggle/collapse-toggle.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { Truncate } from "../../typography/truncate/truncate.mjs";
const CommentsItem = (props) => {
  const {
    allowReplies = true,
    level = 1,
    variant = "default",
    date,
    id,
    isoDate,
    message,
    sender,
    className,
    isReplyCollapseVisible,
    items,
    onReplyCollapseToggle,
    replyButton,
    replyForm
  } = props;
  const BEM = () => {
    const classArray = ["comments__item", "comments__item--".concat(variant)];
    if (level) {
      classArray.push("comments__item--level-" + level);
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const renderMeta = () => /* @__PURE__ */ React.createElement(
    CollapseLayerGrid,
    {
      activeCollapse: isReplyCollapseVisible ? "comment-item-collapse-".concat(id) : void 0,
      onActiveCollapseChange,
      id: "comment-item-collapse-grid-".concat(id),
      className: "comments__item-meta",
      align: ["middle-xs"],
      borderWeight: "thin"
    },
    /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React.createElement("time", { className: "comments__item-date", dateTime: isoDate }, date)),
    replyButton && replyForm && allowReplies && renderReplyColumn(replyButton, replyForm)
  );
  const onActiveCollapseChange = (activeCollapse) => {
    const isActive = activeCollapse === "comment-item-collapse-".concat(id);
    if (onReplyCollapseToggle) {
      onReplyCollapseToggle(isActive);
    }
  };
  const renderReplyColumn = (replyButton2, replyForm2) => /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"], border: ["left-xs"] }, /* @__PURE__ */ React.createElement(CollapseLayerProvider, { id: "comment-item-collapse-".concat(id) }, /* @__PURE__ */ React.createElement(CollapseTrigger, null, /* @__PURE__ */ React.createElement(CollapseToggle, { ...replyButton2, link: true, size: "small", iconRight: "#arrow-down" })), /* @__PURE__ */ React.createElement(CollapseLayer, { color: "grey", noClose: true }, replyForm2)));
  const renderIcon = (icon, size = "xxs") => /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(Icon, { modifiers: icon, size, align: "middle" }));
  const renderSenderName = (sender2) => /* @__PURE__ */ React.createElement("div", { className: "comments__item-sender" }, /* @__PURE__ */ React.createElement(Grid, { noWrap: true, align: ["middle-xs"], gutter: "small" }, level > 1 && renderIcon("#arrow-reply"), sender2.isEmployee && renderIcon("#support", "xs"), /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"] }, /* @__PURE__ */ React.createElement(Truncate, { className: "comments__item-sender-name" }, sender2.name))));
  const renderComments = (items2) => /* @__PURE__ */ React.createElement("div", { className: "comments__item-replies" }, items2.map((comment) => /* @__PURE__ */ React.createElement(CommentsItem, { ...comment, key: comment.id, level: level + 1 })));
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, /* @__PURE__ */ React.createElement("div", { className: "comments__item-inner" }, sender && renderSenderName(sender), /* @__PURE__ */ React.createElement("div", { className: "comments__item-comment-wrapper" }, /* @__PURE__ */ React.createElement("div", { className: "comments__item-comment" }, message), renderMeta())), items && renderComments(items));
};
export {
  CommentsItem
};
